import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class ModalConfirmacionPedidoProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenDetalle: false,
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        disabled: PropTypes.bool,
        missingItems: PropTypes.array,
    }

    resetForm() {
        this.setState({
            errors: [],
        });
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    changeIsOpen = () => {
        const { isOpenDetalle } = this.state;

        if (isOpenDetalle == true) {
            this.resetForm()
            this.setState({ isOpenDetalle: !isOpenDetalle })
        } else {
            this.setState({ isOpenDetalle: !isOpenDetalle });
        }
    }

    onValidate = () => {
        const { } = this.state;

        let errors = {};
        let valid = true;

        this.setState({ errors: errors })

        return valid
    }

    onSubmit = () => {
        this.setState({ isOpenDetalle: false });
        this.props.onSubmit()
    }

    render() {
        const { isOpenDetalle } = this.state;
        const { disabled, title, detalle, observacion, missingItems } = this.props;

        return (
            <Fragment>
                <Button
                    id="helpTp"
                    className="px-5 rounded"
                    color="success"
                    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                    disabled={disabled}
                    onClick={() => !disabled ? this.changeIsOpen() : null}
                >
                    <i className="fa fa-check mr-1"></i>
                    Confirmar Pedido
                </Button>

                {disabled && (
                    <UncontrolledTooltip
                        className="rounded-tooltip"
                        placement="bottom"
                        target="helpTp"
                        style={{ textAlign: 'left' }}
                    >
                        Faltan:
                        <ul className="list-unstyled text-left mb-0">
                            {missingItems.map((item, index) => (
                                <li key={index}>- {item}</li>
                            ))}
                        </ul>
                    </UncontrolledTooltip>
                )}
                <Modal isOpen={isOpenDetalle} toggle={() => this.changeIsOpen()} className={"modal-primary modal-lg"}>
                    <ModalHeader>{title}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col className={'col-12'}>
                                {/* Lista de los productos seleccionados */}
                                <Table striped hover size="sm" className="mt-3 tvp">
                                    <thead>
                                        <tr>
                                            <th width={'5%'}>N°</th>
                                            <th>Nombre</th>
                                            <th>Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(detalle.length == 0) ?
                                            <tr>
                                                <td className="text-center" colSpan={3}>No hay pedidos agregados</td>
                                            </tr>
                                            :
                                            detalle.map((d, i) =>
                                                <tr key={(i)} >
                                                    <td width={'5%'}>{i + 1}</td>
                                                    <td>{d.nombre}</td>
                                                    <td>{d.cantidad}</td>
                                                </tr>
                                            )}
                                    </tbody>
                                </Table>
                            </Col>

                            <Col className={'col-12'}>
                                <ParadigmaLabeledInput
                                    type={'textarea'}
                                    maxLength={1000}
                                    label={"Observación"}
                                    value={observacion}
                                    onChange={(e) => this.props.onChangeObservacion(e)}
                                    error={() => this.getError('observacion')}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {/* al confirmar se realiza el submit */}
                        <Button className="rounded" color="success" onClick={() => this.onSubmit()}>Confirmar</Button>{' '}
                        <Button className="rounded" color="secondary" onClick={() => this.changeIsOpen()}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default ModalConfirmacionPedidoProducto;


// WEBPACK FOOTER //
// ./src/views/PedidosProducto/ModalConfirmacionPedidoProducto.js